<template>
  <span
    class="inline-flex w-fit items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-semibold leading-5"
    :style="toneStyles.badge"
  >
    <span
      class="h-1.5 w-1.5 rounded-full"
      :style="toneStyles.dot"
    />
    {{ displayLabel }}
  </span>
</template>

<script>
import { computed } from 'vue'

const TONES = {
  complete: {
    badge: { backgroundColor: '#e8f7ff', borderColor: '#bfeaff', color: '#009fe3' },
    dot: { backgroundColor: '#009fe3' }
  },
  active: {
    badge: { backgroundColor: '#e9fbea', borderColor: '#b9efc4', color: '#00b52f' },
    dot: { backgroundColor: '#00b52f' }
  },
  pending: {
    badge: { backgroundColor: '#f3eaff', borderColor: '#dbc7ff', color: '#6b21e8' },
    dot: { backgroundColor: '#6b21e8' }
  },
  paused: {
    badge: { backgroundColor: '#fffbeb', borderColor: '#fde68a', color: '#b45309' },
    dot: { backgroundColor: '#f59e0b' }
  },
  cancelled: {
    badge: { backgroundColor: '#fff1f2', borderColor: '#fecdd3', color: '#be123c' },
    dot: { backgroundColor: '#f43f5e' }
  },
  neutral: {
    badge: { backgroundColor: '#f8fafc', borderColor: '#e2e8f0', color: '#334155' },
    dot: { backgroundColor: '#94a3b8' }
  }
}

const STATUS_TONE = {
  active: 'active',
  open: 'active',
  current: 'active',
  'in progress': 'active',
  complete: 'complete',
  completed: 'complete',
  done: 'complete',
  closed: 'complete',
  pending: 'pending',
  planned: 'pending',
  planning: 'pending',
  design: 'pending',
  development: 'active',
  uat: 'pending',
  paused: 'paused',
  hold: 'paused',
  'on hold': 'paused',
  cancelled: 'cancelled',
  canceled: 'cancelled'
}

const humanize = (value) => {
  const text = String(value || '').trim()
  if (!text) return 'Unknown'
  return text
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase())
}

export default {
  name: 'StatusBadge',
  props: {
    status: { type: [String, Number], default: '' },
    label: { type: String, default: '' }
  },
  setup(props) {
    const displayLabel = computed(() => props.label || humanize(props.status))
    const normalized = computed(() => String(props.status || displayLabel.value).trim().toLowerCase())
    const toneStyles = computed(() => TONES[STATUS_TONE[normalized.value] || 'neutral'])

    return { displayLabel, toneStyles }
  }
}
</script>
